var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container"},[_c('apex-charts',{staticClass:"radial-chart",attrs:{"width":"500","type":"radialBar","options":_vm.chartOptions,"series":_vm.progressValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }